import type { APIWithPagination, APIWithSlug, DeepQueryParams, SWRConfigInterface } from '@gik/core/api/BaseAPIConfig';
import { wpApi } from '@gik/core/api/ky/wpApi';
import { useWPApi } from '@gik/core/api/swr/useWPApi';
import type WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import PostsUrlBuilder from './PostsUrlBuilder';

const path = 'posts';

export interface PostsParams extends APIWithPagination, APIWithSlug {
  situationSlug?: string;
  ids?: string[];
}

export function getParams(params: PostsParams): DeepQueryParams {
  // prettier-ignore
  const builder = new PostsUrlBuilder()
  .withPerPage(params.perPage)
  .withSlug(params.slug)
  .withIds(params.ids)
  .withPreviewMode(true);

  if (params.slug) {
    builder.withProductBundles().withBuyingGuides();
  }

  return builder.params;
}

export function getPosts(params: PostsParams) {
  return wpApi
    .get(path, {
      searchParams: getParams(params),
    })
    .json<WordpressPost[]>();
}

export function usePosts(params: PostsParams, config?: SWRConfigInterface) {
  return useWPApi<WordpressPost[]>(path, getParams(params), config);
}
